import angular from "angular";
import { $http, $localStorage } from "ng";
export const DISABLED =
  (ENV_TAGS || []).indexOf("Offline") >= 0 ||
  (ENV_TAGS || []).indexOf("Showroom") >= 0; //webpack.DefinePlugin

const bootswatch = {
  theme: $localStorage.bootswatchTheme || "cerulean",
  query:
    !DISABLED &&
    $http.get("https://bootswatch.com/api/3.json").then((res) => {
      bootswatch.map = {};
      Object.assign(bootswatch, res.data);
      res.data.themes.forEach((t) => (bootswatch.map[t.name] = t));
    }),
  setTheme(theme) {
    bootswatch.theme = $localStorage.bootswatchTheme = (
      angular.isObject(theme) ? theme.name : theme
    ).toLowerCase();
  },
};

export default bootswatch;
